import { observer } from "mobx-react";
import React from "react";
import {
  AspectRatio,
  Center,
  Stack,
  Text,
  Group,
  CopyButton,
  Anchor,
  ActionIcon,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconCopy, IconCheck } from "@tabler/icons-react";
import { QRCodeSVG } from "qrcode.react";
import { Bob } from "../../../stores/Bob";

// `invoice` shows a specific bolt11 (the hold invoices page); without it,
// the invoice the user just created on the Receive screen
const UserCreatedInvoiceQR = observer(
  ({ bob, invoice: invoiceProp }: { bob: Bob; invoice?: string | null }) => {
  /*  Detect "tiny" screens (≤ 320 px wide). JioPhone 2 is 240 px.  */
  const isTinyScreen = useMediaQuery("(max-width: 320px)");

  const invoice = invoiceProp ?? bob.userCreatedInvoicePayRequest;
  if (!invoice) return null; // nothing to show yet

  /*  QR size: 300 px everywhere except tiny screens (shrink to 200 px).  */
  const qrSize = isTinyScreen ? 200 : 300;

  const payLink = `lightning:${invoice}`;

  return (
    <Stack gap="xs" mt="md">
      {/* QR is now a clickable lightning: link */}
      <Center>
        <AspectRatio ratio={1} style={{ maxWidth: qrSize }}>
          <Anchor href={payLink} underline="never" style={{ display: "block" }}>
            <QRCodeSVG
              value={invoice}
              size={qrSize}
              bgColor="#ffffff"
              fgColor="#000000"
              marginSize={2}
              level="L"
              title="User-generated invoice"
            />
          </Anchor>
        </AspectRatio>
      </Center>

      {/* Copy-to-clipboard button with a tiny preview of the invoice */}
      <Center>
        <Group gap="xs">
          <CopyButton value={invoice}>
            {({ copied, copy }) => (
              <ActionIcon
                size="lg"
                variant={copied ? "filled" : "default"}
                color={copied ? "teal" : "blue"}
                onClick={copy}
                aria-label="copy invoice"
              >
                {copied ? <IconCheck /> : <IconCopy />}
              </ActionIcon>
            )}
          </CopyButton>

          <Text>Copy invoice as text</Text>
        </Group>
      </Center>
    </Stack>
  );
  },
);

export default UserCreatedInvoiceQR;
